// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.piMX6xnvMPXZRPQxNguO {
    width: 100%;
}

.piMX6xnvMPXZRPQxNguO select {
    width: 100%;
}

.piMX6xnvMPXZRPQxNguO input[type="text"] {
    padding: 4px 8px;
}

.f05DKSdj2V9UdLNodagk {
    width: 25%;
}

.mKf4AxeETnjC4zEA9BMY {
}

.akBxRVC1fnvfGsuVAHGk {
    padding: 0 !important;
    vertical-align: middle !important;
}

.FJ7k6iamFpN2zCfTih7I {
}

.s1jDHKCJUxjmRi86NxsR {
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/admin/import/interest_imports/components/fields.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;AAEA;;AAEA;IAEI,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;AAEA;;AAEA;AAEA","sourcesContent":[".table {\n    width: 100%;\n}\n\n.table select {\n    width: 100%;\n}\n\n.table input[type=\"text\"] {\n    padding: 4px 8px;\n}\n\n.data {\n    width: 25%;\n}\n\n.dataName {\n    composes: data;\n}\n\n.dataPreview {\n    composes: data;\n    padding: 0 !important;\n    vertical-align: middle !important;\n}\n\n.dataMapped {\n    composes: data;\n}\n\n.dataFormat {\n    composes: data;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `piMX6xnvMPXZRPQxNguO`,
	"data": `f05DKSdj2V9UdLNodagk`,
	"dataName": `mKf4AxeETnjC4zEA9BMY f05DKSdj2V9UdLNodagk`,
	"dataPreview": `akBxRVC1fnvfGsuVAHGk f05DKSdj2V9UdLNodagk`,
	"dataMapped": `FJ7k6iamFpN2zCfTih7I f05DKSdj2V9UdLNodagk`,
	"dataFormat": `s1jDHKCJUxjmRi86NxsR f05DKSdj2V9UdLNodagk`
};
export default ___CSS_LOADER_EXPORT___;
